import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { merge, of } from 'rxjs';
import { catchError, filter, mapTo, shareReplay, startWith, switchMap, take, tap } from 'rxjs/operators';
import { AppService } from './shared/app.service';
import { SubsManager } from './shared/subs-manager';
import { AuthService } from './auth/auth.service';
import { UserService } from './shared/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {


  private readonly subsMgr = new SubsManager();
  readonly state$ = this.router.events.pipe(
    filter((x): x is NavigationEnd => x instanceof NavigationEnd),
    take(1),
    mapTo('ready'),
    startWith('loading'),
    shareReplay(1)
  );

  state: 'loading' | 'ready' = 'ready';

  userInfo = this.userService.userInfo;

  constructor(private appSvc: AppService, 
              private authSvc: AuthService,
              private router: Router,
              private userService: UserService) {
  }

  ngOnInit() {    
     this.state = 'loading';
    // when navigation fails go home.     
    // if stuck in a loop - check here
    this.subsMgr.addSub = this.router.events.pipe(
      filter(x => x instanceof NavigationError),
      tap(() => {
        this.router.navigate(['/']);
    })
    ).subscribe(x =>
      this.state = 'ready'
    );

    // add user name to telemetry.
    this.subsMgr.addSub = merge(
      this.authSvc.authResult$.pipe(filter(x => x?.account?.name === 'userLoaded')),
    ).pipe(
      switchMap(() => this.appSvc.user$),
      catchError(() => of(undefined)),
    ).subscribe(x =>
      this.state = 'ready'
    );
  }

  ngOnDestroy() {
    this.subsMgr.onDestroy();
  }
}
